export default "__VITE_ASSET__vtSnvvEL__"